import { render, staticRenderFns } from "./FixedLayout.vue?vue&type=template&id=58a7e16d&scoped=true&"
import script from "./FixedLayout.vue?vue&type=script&lang=js&"
export * from "./FixedLayout.vue?vue&type=script&lang=js&"
import style0 from "./FixedLayout.vue?vue&type=style&index=0&id=58a7e16d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a7e16d",
  null
  
)

export default component.exports